import React from "react";
import { CheckCircle, Circle } from "lucide-react";

const STATUS_STEPS = [
  { key: "pending", label: "Order Placed" },
  { key: "confirmed", label: "Partner Assigned" },
  { key: "picked_up", label: "Picked Up" },
  { key: "in_transit", label: "In Transit" },
  { key: "delivered", label: "Delivered" },
];

/**
 * Displays delivery progress steps with visual indicators
 */
export function TrackingProgress({ currentStep, isActive }) {
  return (
    <div className="border border-border p-6 mb-6">
      <h2 className="font-bold mb-6">Delivery Progress</h2>
      <div className="relative">
        {STATUS_STEPS.map((step, index) => {
          const isCompleted = index <= currentStep;
          const isCurrent = index === currentStep;
          
          return (
            <div key={step.key} className="flex gap-4 mb-5 last:mb-0">
              <div className="flex flex-col items-center">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${
                  isCompleted ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground"
                } ${isCurrent ? "ring-4 ring-primary/20 scale-110" : ""}`}>
                  {isCompleted ? <CheckCircle className="w-4 h-4" /> : <Circle className="w-4 h-4" />}
                </div>
                {index < STATUS_STEPS.length - 1 && (
                  <div className={`w-0.5 h-8 ${index < currentStep ? "bg-primary" : "bg-border"}`} />
                )}
              </div>
              <div className={`pt-1 ${isCurrent ? "font-bold" : ""}`}>
                <p className={isCompleted ? "text-foreground" : "text-muted-foreground"}>{step.label}</p>
                {isCurrent && isActive && (
                  <div className="flex items-center gap-1 mt-1">
                    <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
                    <p className="text-xs text-primary">Current</p>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// Export STATUS_STEPS for parent component to use
TrackingProgress.STATUS_STEPS = STATUS_STEPS;
